"use client";
import { useMutation } from "@tanstack/react-query";
import { useTenantRouteContext } from "@/components/app-shell/TenantRouteContext";
import { postApiCcofPracticeIdCaptureStaff } from "@/lib/api-client/endpoints/ccof-capture/ccof-capture";
import type { CcofCaptureInitiateResponse } from "lib/api-types/schemas";

export function useCaptureSession() {
  const { tenantId } = useTenantRouteContext();

  return useMutation<CcofCaptureInitiateResponse, Error, string>({
    mutationFn: (patientId: string) =>
      postApiCcofPracticeIdCaptureStaff(tenantId, {
        patientId,
        consentAccepted: true,
      }).then((res) => res.data),
  });
}
